import React from 'react';
import { BeatLoading } from 'respinner';
import { bem } from '../../lib';
export const LoadingIndicator = props => {
    return (React.createElement(BeatLoading, { count: 4, size: 5, className: bem('spinner__svg', '--beat') }));
};
//# sourceMappingURL=LoadingIndicator.js.map